<template>
  <div v-if="loaded">
    <div
        class="alert alert-danger alert-dismissible fade show p-2 mb-2"
        role="alert"
        v-if="check_system.upload_max_filesize"
    >
      <strong>Informação!</strong> A configuração "upload_max_filesize" está abaixo do recomendado (400M) para upload de vídeos.
      <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div
        class="alert alert-danger alert-dismissible fade show p-2 mb-2"
        role="alert"
        v-if="check_system.post_max_size"
    >
      <strong>Informação!</strong> A configuração "post_max_size" está abaixo do recomendado (400M) para upload de vídeos.
      <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div
        class="alert alert-danger alert-dismissible fade show p-2 mb-2"
        role="alert"
        v-if="check_system.max_execution_time"
    >
      <strong>Informação!</strong> A configuração "max_execution_time" está abaixo do recomendado (300s) para processamento de vídeos.
      <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="d-flex justify-content-between">
      <div class="col-8 card p-1">
        <LMap style="height: 430px;" :zoom="7" :center="centro">
          <LTileLayer :url="'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'"></LTileLayer>
          <LMarker
            v-for="unidade, index in unidades"
            :key="unidade.id" 
            v-if="unidade.lat && unidade.long" 
            :lat-lng="[unidade.lat, unidade.long]"
            :icon="customIcon"
          >
            <LPopup class="d-flex align-items-center justify-content-center flex-column">
              <h5><b>{{ unidade.nome }}</b></h5>
              <h6><b>Última sincronização:</b> {{ unidade.ultima_sincronizacao ? unidade.ultima_sincronizacao_f : "Nunca sincronizado"  }}</h6>
              <button class="btn btn-primary" @click="detalhes(index)">Ver detalhes</button>
            </LPopup>
          </LMarker>
        </LMap>

        <div class="modal fade" id="detalhesModal" tabindex="-1" role="dialog" aria-labelledby="detalhesModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title text-light" id="detalhesModalLabel">{{ unidadeModal.nome }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <h6>Última sincronização: {{ unidadeModal.ultima_sincronizacao ? unidadeModal.ultima_sincronizacao_f : "Nunca sincronizado"  }}</h6>
                  </div>
                  <div class="col-md-6">
                    <label>ID da unidade</label>
                    <input type="text" class="form-control" v-model="unidadeModal.id" disabled />
                  </div>
                  <div class="col-md-6">
                    <label>CNES</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="unidadeModal.cnes" disabled />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label>Nome</label>
                    <input type="text" class="form-control" v-model="unidadeModal.nome" id="nome" disabled />
                  </div>
                  <div class="col-md-12">
                    <label>Nome fantasia</label>
                    <input type="text" class="form-control" v-model="unidadeModal.nome_fantasia" disabled />
                  </div>
                  <div class="col-md-12">
                    <label>Razão social</label>
                    <input type="text" class="form-control" v-model="unidadeModal.razao_social" disabled />
                  </div>
                  <div class="col-md-6">
                    <label>CNPJ da entidade</label>
                    <input type="text" class="form-control" v-model="unidadeModal.cnpj_entidade" v-mask="'99.999.999/9999.99'" disabled />
                  </div>
                  <div class="col-md-6">
                    <label>CNPJ da unidade</label>
                    <input type="text" class="form-control" v-model="unidadeModal.cnpj_unidade" v-mask="'99.999.999/9999.99'" disabled />
                  </div>
                  <div class="col-md-6">
                    <label>Tipo de unidade</label>
                    <select class="form-control" v-model="unidadeModal.tipo_unidade" disabled>
                      <option :key="1" :value="1">POSTO DE SAUDE</option>
                      <option :key="2" :value="2">CENTRO DE SAUDE/UNIDADE BASICA</option>
                      <option :key="4" :value="4">POLICLINICA</option>
                      <option :key="5" :value="5">HOSPITAL GERAL</option>
                      <option :key="7" :value="7">HOSPITAL ESPECIALIZADO</option>
                      <option :key="15" :value="15">UNIDADE MISTA</option>
                      <option :key="20" :value="20">PRONTO SOCORRO GERAL</option>
                      <option :key="21" :value="21">PRONTO SOCORRO ESPECIALIZADO</option>
                      <option :key="22" :value="22">CONSULTORIO ISOLADO</option>
                      <option :key="32" :value="32">UNIDADE MOVEL FLUVIAL</option>
                      <option :key="36" :value="36">CLINICA/CENTRO DE ESPECIALIDADE</option>
                      <option :key="39" :value="39">UNIDADE DE APOIO DIAGNOSE E TERAPIA (SADT ISOLADO)</option>
                      <option :key="40" :value="40">UNIDADE MOVEL TERRESTRE</option>
                      <option :key="42" :value="42">UNIDADE MOVEL DE NIVEL PRE-HOSPITALAR NA AREA DE URGENCIA</option>
                      <option :key="43" :value="43">FARMACIA</option>
                      <option :key="50" :value="50">UNIDADE DE VIGILANCIA EM SAUDE</option>
                      <option :key="60" :value="60">COOPERATIVA OU EMPRESA DE CESSAO DE TRABALHADORES NA SAUDE</option>
                      <option :key="61" :value="61">CENTRO DE PARTO NORMAL - ISOLADO</option>
                      <option :key="62" :value="62">HOSPITAL/DIA - ISOLADO</option>
                      <option :key="64" :value="64">CENTRAL DE REGULACAO DE SERVICOS DE SAUDE</option>
                      <option :key="67" :value="67">LABORATORIO CENTRAL DE SAUDE PUBLICA LACEN</option>
                      <option :key="68" :value="68">CENTRAL DE GESTAO EM SAUDE</option>
                      <option :key="69" :value="69">CENTRO DE ATENCAO HEMOTERAPIA E OU HEMATOLOGICA</option>
                      <option :key="70" :value="70">CENTRO DE ATENCAO PSICOSSOCIAL</option>
                      <option :key="71" :value="71">CENTRO DE APOIO A SAUDE DA FAMILIA</option>
                      <option :key="72" :value="72">UNIDADE DE ATENCAO A SAUDE INDIGENA</option>
                      <option :key="73" :value="73">PRONTO ATENDIMENTO</option>
                      <option :key="74" :value="74">POLO ACADEMIA DA SAUDE</option>
                      <option :key="75" :value="75">TELESSAUDE</option>
                      <option :key="76" :value="76">CENTRAL DE REGULACAO MEDICA DAS URGENCIAS</option>
                      <option :key="77" :value="77">SERVICO DE ATENCAO DOMICILIAR ISOLADO(HOME CARE)</option>
                      <option :key="78" :value="78">UNIDADE DE ATENCAO EM REGIME RESIDENCIAL</option>
                      <option :key="79" :value="79">OFICINA ORTOPEDICA</option>
                      <option :key="80" :value="80">LABORATORIO DE SAUDE PUBLICA</option>
                      <option :key="81" :value="81">CENTRAL DE REGULACAO DO ACESSO</option>
                      <option :key="82" :value="82">CENTRAL DE NOTIFICACAO,CAPTACAO E DISTRIB DE ORGAOS ESTADUAL</option>
                      <option :key="83" :value="83">POLO DE PREVENCAO DE DOENCAS E AGRAVOS E PROMOCAO DA SAUDE</option>
                      <option :key="84" :value="84">CENTRAL DE ABASTECIMENTO</option>
                      <option :key="85" :value="85">CENTRO DE IMUNIZACAO</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label>Tipo da gestão</label>
                    <select class="form-control" v-model="unidadeModal.tipo_unidade" disabled>
                      <option :key="1" :value="1">Estadual</option>
                      <option :key="2" :value="2">Municipal</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label>CEP</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="unidadeModal.cep" v-mask="'99999-999'" disabled />
                    </div>
                  </div>
                  <div class="col-md-7">
                    <label>Logradouro</label>
                    <input type="text" class="form-control" v-model="unidadeModal.logradouro" disabled />
                  </div>
                  <div class="col-md-2">
                    <label>Número</label>
                    <input type="text" class="form-control" v-model="unidadeModal.numero" disabled />
                  </div>
                  <div class="col-md-3">
                    <label>Complemento</label>
                    <input type="text" class="form-control" v-model="unidadeModal.complemento" disabled />
                  </div>
                  <div class="col-md-3">
                    <label>Bairro</label>
                    <input type="text" class="form-control" v-model="unidadeModal.bairro" disabled />
                  </div>
                  <div class="col-md-3">
                    <label>Município</label>
                    <input type="text" class="form-control" v-model="unidadeModal.municipio" disabled />
                  </div>
                  <div class="col-md-3">
                    <label>Estado</label>
                    <input type="text" class="form-control" v-model="unidadeModal.uf" disabled />
                  </div>
                  <div class="col-md-12">
                    <label>Telefone</label>
                    <input type="text" class="form-control" v-model="unidadeModal.telefone" disabled />
                  </div>
                  <div class="col-md-12">
                    <label>Email</label>
                    <input type="text" class="form-control" v-model="unidadeModal.email" disabled />
                  </div>
                </div>
              </div>
              <div class="modal-footer">

              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="card d-flex justify-content-center align-items-center flex-column" style="width: 32.5%;">
      <div class="col-12 text-center">
        <h4 class="mt-1">Unidades</h4>
          <div
            v-for="(unidade, index) in unidades"
            @click="detalhes(index)"
            class="item-lista-unidade"
            :class="unidade.atualizado ? 'sincronizado' : 'nao-sinconizado'"
          >
            {{ unidade.nome }} <br>
            {{ unidade.ultima_sincronizacao ? unidade.ultima_sincronizacao_f : "Nunca sincronizado" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BIconChevronCompactLeft, BLink } from "bootstrap-vue";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;

const customIcon = new L.Icon({
  iconUrl: require('@/assets/images/hospital.png'),
  iconSize: [30, 30],
  iconAnchor: [12, 12],
  popupAnchor: [1, -34],
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [41, 41],
});

export default {
  data() {
    return {
      loaded: false,
      unidades: [],
      check_system: {},
      unidadeModal: {
        nome: "",
      },
      centro: [-14.235, -51.925],
      dashboard: [],
      customIcon,
    };
  },
  computed: {
    hasSystemIssues() {
      return this.check_system.base_synchronization ||
             this.check_system.time_delay_password ||
             this.check_system.user_login_synchronization ||
             this.check_system.user_password_synchronization ||
             this.check_system.upload_max_filesize ||
             this.check_system.post_max_size ||
             this.check_system.max_execution_time;
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
  },
  methods: {
    checkSystem: function () {
      const self = this;
      const api = self.$store.state.api + "check-system";

      axios
          .get(api)
          .then((response) => {
            self.check_system = response.data;
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
    },
    getunidade: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false"

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;

          let totalLat = 0;
          let totalLong = 0;
          let validCount = 0;

          self.unidades.forEach(unidade => {
   
            if(unidade.lat === null && unidade.long === null)
            {
              self.getCoordenadas(unidade, unidade.logradouro + ', ' + unidade.numero);
            } else if (unidade.lat && unidade.long) {
              totalLat += parseFloat(unidade.lat);
              totalLong += parseFloat(unidade.long);
              validCount++;
            }
          });

          if (validCount > 0) {
            self.centro = [totalLat / validCount, totalLong / validCount];
          }
          
          setTimeout(() => {
            self.loaded = true;
          }, 1000);
        })
        .catch((error) => {
          console.log(error)
          self.$message(null, error, "error");
        });
    },
    detalhes: function (index) {
      const self = this;

      self.unidadeModal = self.unidades[index];

      $("#detalhesModal").modal('toggle');
    },
    async getCoordenadas(unidade, endereco) {
      const self = this;
      const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(endereco)}&format=json`;

      try {
        const response = await axios.get(url);

        if (response.data && response.data.length > 0) {
          const lat = parseFloat(response.data[0].lat);
          const lon = parseFloat(response.data[0].lon);

          self.setCoordenadas(unidade, lat, lon);

          return [lat, lon];
        } else {
          console.log('Endereço não encontrado.');

          return null;
        }
      } catch (error) {
        console.error('Erro ao buscar coordenadas:', error);

        return null;
      }
    },
    async setCoordenadas(unidade, lat, long) {
      const self = this;
      const api = self.$store.state.api + "unidades/" + unidade.id;

      unidade.lat = lat,
      unidade.long = long,
      unidade._method = "PUT",

      axios
        .post(api, unidade)
        .then(() => {

        })
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted() {
    const self = this;

    self.checkSystem();
    self.getunidade();
  },
  created() {},
};
</script>

<style>
.sincronizado{
background: #cfc;
  color: #070;
}
.sincronizado:hover{
background: #efe;
  color: #030;
}
.nao-sinconizado{
  background: #fcc;
  color: #700;
}
.nao-sinconizado:hover{
  background: #fee;
  color: #300;
}
.item-lista-unidade {
  border-top: 1px solid #ccc;
  cursor: pointer;
  padding: 8px;
}
</style>
